import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ProviderSearchRequestAction, ProviderSearchResponseAction, TransferOptionsRequestAction, TransferOptionsResponseAction } from './actions';
import { EMPTY } from 'rxjs';
import { RollinService } from 'src/app/services/rollin.service';

@Injectable()
export class NmjRollinEffects {
    constructor(private actions$: Actions,
        private rollinService: RollinService) {
    }

    transferOptions$ = createEffect(() => this.actions$.pipe(
        ofType(TransferOptionsRequestAction),
        switchMap((_action: any) => this.rollinService.getTransferOptions().pipe(
            map((data: any) => {
                return TransferOptionsResponseAction({ transferOptions: data.data });
            }),
            catchError(_err => {
                return EMPTY;
            })
        )),
    ));

    providerSearch$ = createEffect(() => this.actions$.pipe(
        ofType(ProviderSearchRequestAction),
        switchMap((action: any) => this.rollinService.providerSearch(action.q).pipe(
            map((data: any) => {
                return ProviderSearchResponseAction({ payload: data.data });
            }),
            catchError(_err => {
                return EMPTY;
            })
        )),
    ));
}
